import { AxiosResponse } from 'axios'
import { RequestCDU } from 'services/Instances'

const MovDocumentItemServices = () => {
  const path = 'MovDocumentoItem'

  const CreateMovDocumentItemsGED = async (
    body: CreateMovDocumentItemsGEDBody[]
  ): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/CreateMovDocumentoItemGED`, body)

  const UpdateStatusMovDocumentItem = async (
    id: number,
    newStatus: string,
    idUsuario: number
  ): Promise<AxiosResponse> =>
    await RequestCDU.patch(
      `${path}/UpdateStatus?id=${id}&newStatus=${newStatus}&idUsuario=${idUsuario}`
    )

  return { CreateMovDocumentItemsGED, UpdateStatusMovDocumentItem }
}

export interface CreateMovDocumentItemsGEDBody {
  idMovDocumentoItem: number
  movDocumentoId: number
  gedExternalId: string
  dtAnexado: string
  txVersao: string
  cdStatus: string
  txFilename: string
  justificativa: string
  tipoPendenciaId: number
  file: string
  cdDocto: string
  competencia: number
  fornecedor: string
  contratoId: number
}

export { MovDocumentItemServices }
